import { useTranslation } from 'react-i18next';
import { useReveal } from '@/shared/hooks/useReveal';
import styles from './Services.module.css';

export function Services() {
  const { t } = useTranslation();
  const ref = useReveal();

  const cards = [
    { key: 'therapy', variant: styles.therapy },
    { key: 'education', variant: styles.education },
  ] as const;

  return (
    <section id="servicios" className="section">
      <div className="container">
        <div className="section__head">
          <span className="eyebrow">{t('services.title')}</span>
          <h2>{t('services.subtitle')}</h2>
        </div>

        <div className={`${styles.grid} reveal`} ref={ref}>
          {cards.map((card, i) => (
            <article key={card.key} className={`${styles.card} ${card.variant}`}>
              <span className={styles.index} aria-hidden>
                0{i + 1}
              </span>
              <h3>{t(`services.${card.key}.title`)}</h3>
              <p className="text-soft">{t(`services.${card.key}.description`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
